<template>
    <div>
        <div v-if="props.question.text != null" class="row col mb-2">{{ props.question.text[participant.language] }}</div>
        <div class="row">
            <div class="col-3">
                <input 
                    type="number" 
                    class="form-control"
                    :name="props.question.variable"
                    :min="props.question.inputAttributes.min"
                    :max="props.question.inputAttributes.max"
                    v-model="response[props.question.variable]"
                    @input="event => debounceInput(event, response)"
                >
            </div>
            <div class="col-9">
                <label
                    class="col-form-label"
                    :for="props.question.variable"
                >
                    {{ props.question.label[participant.language] }}
                </label>
            </div>
        </div>
    </div>
</template>


<script setup>
    import { storeToRefs } from 'pinia'
    import { useSurveysStore } from '../../../stores/surveys'
    import debounce from "lodash/debounce"

    const { saveResponse, setError } = useSurveysStore()
    const { participant, response } = storeToRefs(useSurveysStore())
    const props = defineProps(['question'])

    const debounceInput = debounce((event, response) => {
        setError('')
        if (props.question.variable == 'WEIGHT' && (![8, 9].includes(response[props.question.variable]) && response[props.question.variable] < 41))  {
            setError('Please enter a weight greater than 40 lbs.')
        }
        saveResponse()
    }, 1000)
</script>